import { render, staticRenderFns } from "./MerchantKYC.vue?vue&type=template&id=550238eb"
import script from "./MerchantKYC.vue?vue&type=script&lang=js"
export * from "./MerchantKYC.vue?vue&type=script&lang=js"
import style0 from "./MerchantKYC.vue?vue&type=style&index=0&id=550238eb&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('550238eb')) {
      api.createRecord('550238eb', component.options)
    } else {
      api.reload('550238eb', component.options)
    }
    module.hot.accept("./MerchantKYC.vue?vue&type=template&id=550238eb", function () {
      api.rerender('550238eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MerchantKYC/MerchantKYC.vue"
export default component.exports